import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'
import { FormattedMessage } from 'react-intl'
import messages from '@utils/messages'

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(4),
      padding: theme.spacing(4, 6),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.error.main,
    },
    message: {
      color: theme.palette.common.white,
      lineHeight: 1,
      fontSize: theme.typography.pxToRem(15),
    },
    errorIcon: {
      color: theme.palette.common.white,
      marginRight: theme.spacing(3),
    },
  }
})

interface ListErrorProps {
  message?: React.ReactNode
}

const ListError: React.FC<ListErrorProps> = ({
  message = <FormattedMessage {...messages.GENERIC_ERROR} />,
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <ErrorIcon className={classes.errorIcon} />
      <div className={classes.message}>{message}</div>
    </div>
  )
}

export default ListError
